/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const cog = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.094 2.048a1.218 1.218 0 0 0 1.81 0l.59-.646a1.22 1.22 0 0 1 2.122.88l-.044.871a1.22 1.22 0 0 0 1.277 1.279l.871-.045a1.22 1.22 0 0 1 .878 2.123l-.649.585a1.22 1.22 0 0 0 0 1.811l.649.585a1.22 1.22 0 0 1-.88 2.123l-.871-.044a1.219 1.219 0 0 0-1.28 1.28l.044.871a1.22 1.22 0 0 1-2.117.878l-.586-.648a1.22 1.22 0 0 0-1.81 0l-.589.648a1.22 1.22 0 0 1-2.12-.877l.045-.871a1.219 1.219 0 0 0-1.28-1.28l-.872.044a1.219 1.219 0 0 1-.881-2.12l.648-.586a1.22 1.22 0 0 0 0-1.81l-.648-.589a1.219 1.219 0 0 1 .877-2.12l.872.044a1.219 1.219 0 0 0 1.28-1.282l-.04-.872a1.22 1.22 0 0 1 2.12-.878l.585.646Z"
      clipRule="evenodd"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.003 10.804a2.801 2.801 0 1 0 0-5.602 2.801 2.801 0 0 0 0 5.602Z"
      clipRule="evenodd"
    />
  </svg>
)
export default cog
